import React from 'react';
import { Form } from 'antd';
import { FilterBar2Value, FilterContentProps } from '../types';
import Checkbox from 'components/checkbox/checkbox';

export const FilterContentCheckbox = ({ name, values, onFilterChange }: FilterContentProps) => (
	<Form.Item name={name}>
		<Checkbox.Group>
			{(values as FilterBar2Value[]).map(item => (
				<div className="filter-bar-2-base-row" key={item.value}>
					<Checkbox value={item.value} onChange={onFilterChange}>
						{item.label}
					</Checkbox>
				</div>
			))}
		</Checkbox.Group>
	</Form.Item>
);
